<div style="overflow: hidden;">
	<form [formGroup]="form">
		<div class="form-group mb-3 row">
			<span class="col-lg-2">Port:</span>
			<div class="col-lg-10">
				<input class="form-control" type="text" [value]="ifName" readonly />
			</div>
		</div>
		<div class="form-group mb-3 row" style="margin-top: 30px; align-content: center;">
			<span class="col-lg-2">Status:</span>
			<div class="col-lg-6">
				<select class="form-control" [formControl]="adminStatus" style="padding-top: 0px; padding-bottom: 0px;">
					<option value=""></option>
					<option value="Enable">Enable</option>
					<option value="Disable">Disable</option>
				</select>
			</div>
			<span class="col-lg-1">&nbsp;</span>
			<div class="col-lg-2" style="margin-top: -5px;">
				<button [disabled]="!enableUpdate" type="button" pButton label="Update" 
					icon="fa fa-edit" (click)="update()" title="Set port state on the device"></button>
			</div>
		</div>
		<div class="form-group mb-0 row">
			<div class="uv-row">
				<span class="col-lg-2">&nbsp;</span>
				<button [disabled]="!enableRefresh" type="button" pButton label="Refresh"
					icon="fa fa-refresh" (click)="refresh()" title="Get current port state from the device"></button>
			</div>
		</div>
	</form>
</div>
